import { ISession } from "@/interfaces";

export const mapUserFromApiResponse = (data: any): ISession => {
    const is_registration_complete = !!(data.name && data.email)
    const first_name = data.name ? data.name.split(' ')[0] : ''
    let session: ISession = {
        id: data.id,
        name: data.name,
        email: data.email,
        phone: data.phone,
        type: data.type,
        document_number: data.document_number,
        balance: data.balance,
        is_registration_complete,
        first_name,
    }
    return session
}
